import React, { HTMLAttributes } from 'react';
import c from 'classnames';
import s from './MediumSophisticatedTooltipHeading.scss';

interface Props extends HTMLAttributes<HTMLSpanElement> {}

const MediumSophisticatedTooltipHeading: React.FC<Props> = ({ children, className, ...rest }) => (
  <span className={c(s['root'], className)} {...rest}>
    {children}
  </span>
);
MediumSophisticatedTooltipHeading.displayName = 'MediumSophisticatedTooltipHeading';

export default MediumSophisticatedTooltipHeading;
